import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import type { Change } from '@platform/schema/changes';

/**
 * Old beside new, field by field — GEN-56, shared with GEN-66.
 *
 * Extracted when the chat's proposal needed the same view: a reviewer reading "what would
 * this change" should not have to learn two layouts depending on whether a rewrite or the
 * planner suggested it. What differs between the two is when it is shown and what button
 * sits under it, and that stays with each caller.
 *
 * The row is `Change` from the schema — the same type the generation row carries — so the
 * two callers are not two shapes that happen to match today.
 */

/** An empty string is a field that was blank, which reads as missing rather than as "". */
const shown = (text: string): string => (text === '' ? '—' : text);

export function ChangeTable({ changes }: { changes: readonly Change[] }) {
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Field</TableCell>
          <TableCell>Was</TableCell>
          <TableCell>Now</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {changes.map((change, at) => (
          // Two items on one scene share a field name, so the name is not a key. Rows are
          // rendered from a list that is rebuilt whole, never reordered in place.
          <TableRow key={at}>
            <TableCell>{change.field}</TableCell>
            <TableCell sx={{ color: 'text.secondary' }}>
              {shown(change.before)}
            </TableCell>
            <TableCell>{shown(change.after)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
